<template>
        <div class="zui-spinner-fading-circle" :style='style'>
            <div class="zui-spinner-fading-circle-container zui-spinner-fading-circle-container1">
                <span class="zui-spinner-circle-tl zui-spinner-circle8" :style='dotStyle'></span>
                <span class="zui-spinner-circle-tr zui-spinner-circle2" :style='dotStyle'></span>
                <span class="zui-spinner-circle-br zui-spinner-circle4" :style='dotStyle'></span>
                <span class="zui-spinner-circle-bl zui-spinner-circle6" :style='dotStyle'></span>
            </div>
            <div class="zui-spinner-fading-circle-container zui-spinner-fading-circle-container2">
                <span class="zui-spinner-circle-tl zui-spinner-circle1" :style='dotStyle'></span>
                <span class="zui-spinner-circle-tr zui-spinner-circle3" :style='dotStyle'></span>
                <span class="zui-spinner-circle-br zui-spinner-circle5" :style='dotStyle'></span>
                <span class="zui-spinner-circle-bl zui-spinner-circle7" :style='dotStyle'></span>
            </div>
        </div>
</template>

<script>
export default {
    name: "fadingCircel",
    props: {
        backgroundColor: {
            type: String,
            default: "transparent"
        },
        color: {
            type: String,
            default: "#ccc"
        },
        size: {
            type: String,
            default: "100%"
        },
        dotSize: {
            type: String,
            default: ""
        }
    },

    data() {
        let { color, backgroundColor, size, dotSize } = this;
        let style = this.getStyleStr({
            width: size,
            height: size,
            "background-color": backgroundColor
        });
        let dotStyleObj = {
            "background-color": color
        };
        if (dotSize.length > 0) {
            dotStyleObj = { ...dotStyleObj, width: dotSize, height: dotSize };
        }
        let dotStyle = this.getStyleStr(dotStyleObj);
        return {
            style: style,
            dotStyle: dotStyle
        };
    },
    methods: {
        // 将 style 从对象转为 字符串
        getStyleStr(styles) {
            let styleStr = "";
            for (let key of Object.keys(styles)) {
                styleStr += `${key}:${styles[key]};`;
            }
            return styleStr;
        }
    }
};
</script>

<style scoped lang="scss">
.zui-spinner-fading-circle {
    position: relative;

    .zui-spinner-fading-circle-container {
        position: absolute;
        width: 100%;
        height: 100%;

        @for $i from 1 through 8 {
            .zui-spinner-circle#{$i} {
                animation-delay: $i * 0.13s;
            }
        }
    }

    .zui-spinner-fading-circle-container > span {
        border-radius: 100%;
        display: inline-block;
        border-radius: 50%;
        position: absolute;
        animation: scaleFading 1.04s ease infinite;
        transform: scale(0.3);
        opacity: 0;
        width: 0.28rem;
        height: 0.28rem;
    }

    .zui-spinner-fading-circle-container2 {
        transform: rotateZ(45deg);
    }

    .zui-spinner-circle-tl {
        top: 0;
        left: 0;
    }
    .zui-spinner-circle-tr {
        top: 0;
        right: 0;
    }
    .zui-spinner-circle-br {
        right: 0;
        bottom: 0;
    }
    .zui-spinner-circle-bl {
        left: 0;
        bottom: 0;
    }
}

@keyframes scaleFading {
    0% {
        transform: scale(1.2);
        opacity: 1;
    }
    100% {
        transform: scale(0.3);
        opacity: 0.3;
    }
}
</style>
